import axios from "axios";
import config from "../../config.json";

export const handleApiError = (error, navigate) => {
  console.error("API Error:", error);
  if (error.response && error.response.status === 401) {
    console.log("Unauthorized request");
    navigate("/");
  }
};

export const getRouteById = async (
  effectiveRouteId,
  effectiveOrgId,
  navigate
) => {
  try {


    const resp = await axios.get(
      `${config.baseURL}/route/id?id=${effectiveRouteId}`,
      {
        params: { organizationId: effectiveOrgId },
        withCredentials: true,
      }
    );
    if (resp.status === 401) {
      console.log("Unauthorized request");
      navigate("/");
      return [];
    }
    console.log("Raw route API response:", resp.data);
    return [resp.data];
  } catch (error) {
    handleApiError(error, navigate);
    return [];
  }
};

export const fetchStopsForRoute = async (route, effectiveOrgId, navigate) => {
  const stops = [];
  for (const coordinate of route.routeCoordinates) {
    try {
      const stopsResponse = await axios.get(
        `${config.baseURL}/stop/organization/location`,
        {
          params: {
            organizationId: effectiveOrgId,
            longitude: coordinate.longitude,
            latitude: coordinate.latitude,
          },
          withCredentials: true,
        }
      );
      if (stopsResponse.status === 401) {
        console.log("Unauthorized request");
        navigate("/");
        return [];
      }
      if (stopsResponse.data) {
        stops.push(stopsResponse.data);
      }
    } catch (error) {
      handleApiError(error, navigate);
    }
  }
  return stops
    .flat()
    .filter(
      (stop, index, self) => index === self.findIndex((s) => s.id === stop.id)
    );
};

export const fetchStopDetails = async (stop, index, totalStops, deviceId) => {
  try {

    const response = await axios.post(
      `${config.baseURL}/distance/time/stop`,
      {
        vehicleId: deviceId,
        longitude: stop.longitude,
        latitude: stop.latitude,
        isExtreamPoint: index === 0 || index === totalStops - 1,
      },
      {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      }
    );

    console.log(`Stop ${stop.id} details:`, response.data);
    const distance = isFinite(response.data.distance)
      ? response.data.distance
      : null;
    const eta = isFinite(response.data.eta) ? response.data.eta : null;
    return { distance, eta };
  } catch (error) {
    console.error(`Error fetching details for stop ${stop.id}:`, error);
    return { distance: null, eta: null };
  }
};

export const fetchInitialData = async (
  effectiveRouteId,
  effectiveOrgId,
  effectiveDeviceId,
  setData,
  setLoadingStates,
  setVehicleIds,
  setStopDetails,
  navigate
) => {
  try {
    const routes = await getRouteById(
      effectiveRouteId,
      effectiveOrgId,
      navigate
    );
    console.log("Fetched routes:", routes);
    setData((prev) => ({ ...prev, routes }));
    setLoadingStates((prev) => ({ ...prev, routes: false }));

    if (routes.length > 0) {
      const vehicles = routes[0]?.vehicles || [];
      console.log("Fetched vehicles:", vehicles);
      setData((prev) => ({ ...prev, vehicles }));
      setVehicleIds(vehicles.map((v) => v.device_id));

      const stops = await fetchStopsForRoute(
        routes[0],
        effectiveOrgId,
        navigate
      );
      console.log("Fetched stops:", stops);
      setData((prev) => ({ ...prev, stops }));
      setLoadingStates((prev) => ({ ...prev, stops: false }));

      if (stops.length && effectiveDeviceId) {
        stops.forEach(async (stop, i) => {
          const details = await fetchStopDetails(
            stop,
            i,
            stops.length,
            effectiveDeviceId
          );
          setStopDetails((prev) => ({
            ...prev,
            [stop.id]: details,
          }));
        });
      }
    }
  } catch (error) {
    console.error("Error fetching initial data:", error);
    setLoadingStates((prev) => ({
      ...prev,
      routes: false,
      stops: false,
    }));
  }
};

export const getVehicleAndRouteDetails = async (vehicleId, routeId, orgId) => {
  try {


    const routeResponse = await axios.get(
      `${config.baseURL}/route/id?id=${routeId}`,
      {
        params: { organizationId: orgId },
        withCredentials: true,
      }
    );
    console.log(routeResponse, "routeResponse");

    const vehicle = routeResponse.data?.vehicles?.find(
      (v) => v.id === Number(vehicleId)
    );
    console.log("vehicle naveed", vehicle);

    return {
      routeName: routeResponse.data?.name || "Unknown Route",
      vehicleName: vehicle?.name || "Unknown Vehicle",
    };
  } catch (error) {
    handleApiError(error);
    return {
      routeName: "Unknown Route",
      vehicleName: "Unknown Vehicle",
    };
  }
};
